import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "member_details_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  style: {
    "position": "relative",
    "overflow": "hidden"
  },
  class: "nr"
};
const _hoisted_4 = {
  style: {
    "margin-bottom": "50px",
    "margin-top": "20px"
  },
  class: "bt"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  },
  class: "nr_data"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "详情", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h1", null, _toDisplayString($setup.get_data.title), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", {
    innerHTML: $setup.get_data.text,
    style: {
      "margin-bottom": "100px",
      "width": "80%"
    }
  }, null, 8, _hoisted_6)])]), _createElementVNode("div", {
    class: "collect",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.collect && $setup.collect(...args))
  }, [_createElementVNode("img", {
    src: $setup.get_data.userCollect == 0 ? 'https://www.mimodental.com/assets/imgData/imgs/wsc.png' : 'https://www.mimodental.com/assets/imgData/img/new/ysc.png',
    alt: ""
  }, null, 8, _hoisted_7), _createElementVNode("span", {
    style: _normalizeStyle('color:' + ($setup.get_data.userCollect == 0 ? '#000;' : '#41B9B2;'))
  }, "收藏", 4)])]);
}